<template>
    <st-tooltip-styled> </st-tooltip-styled>
</template>
<script>
import styled, { keyframes } from "vue-styled-components";
import CheckboxImage from "../assets/checkbox.png";

const props = {
    trigger: Boolean,
    active: Boolean
};

const StTooltipStyled = styled("label", props)``;

export default {
    name: "StTooltip",
    data: () => ({
        active: false
    }),
    props: {
        trigger: Boolean
    },
    methods: {},
    components: {
        StTooltipStyled
    }
};
</script>